import type { Translations } from '~/utils/translations/types';

const getNestedValue = (obj: any, path: string) => path.split('.').reduce((o, i) => o?.[i], obj);

export const buildTranslate =
  (translations: Translations, businessUnit: string) =>
  (key: string, params?: Record<any, any>): string => {
    let translationKey = key;

    if (params?.count !== undefined) {
      if (params.count === 0) {
        translationKey = `${translationKey}_0`;
      } else if (params.count === 1) {
        translationKey = `${translationKey}_1`;
      } else {
        translationKey = `${translationKey}_other`;
      }
    }

    const businessUnitKey = `${translationKey}_${businessUnit.toLowerCase()}`;
    let translation = getNestedValue(translations, businessUnitKey) ?? getNestedValue(translations, translationKey);

    if (typeof translation === 'string') {
      // one pass, with a function: a value can come from a URL, and must not be read as a placeholder of the next
      // pass ("{{city}}") nor as a replacement pattern ("$&")
      translation = translation.replace(/\{\{(.*?)}}/g, (_, paramName) => params?.[paramName]);
    }

    return translation || '';
  };

export type Translator = ReturnType<typeof buildTranslate>;
